var plugin_rtlignore_default = {
  "alignLeft": "vrHMO",
  "textWrapNowrap": "_12NWI",
  "alignRight": "iZAYU",
  "alignCenter": "kEuUz",
  "sizeFullWidth": "_3kQij",
  "renderedInTable": "_2zBgA",
  "sizeOriginal": "Dj85v",
  "sizeContent": "-x4Li",
  "sizeSmall": "bCvAi",
  "sizeSmallCenter": "iEuii",
  "flex": "kRamR",
  "atomic": "JjD70",
  "embed": "GHlWq",
  "horizontalScrollbar": "CC95O",
  "pluginContainerMobile": "DH17q"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
